import type { SearchPartnerDriversPayload } from 'src/interfaces/partnerDriver'

/**
 * Phones are stored as E.164 and matched with `ILIKE %…%`, so "(415) 555-0132" would never match
 * "+14155550132". Keep the digits, and a leading `+` when the user typed one.
 */
export const normalizePhoneQuery = (value: string): string => {
  const trimmed = value.trim()
  const digits = trimmed.replace(/\D/g, '')

  if (digits === '') {
    return ''
  }

  if (trimmed.startsWith('+')) {
    return `+${digits}`
  }

  return digits
}

/** The search lives in the URL, so Back from a driver page restores the same results. */
export const readSearchQuery = (searchParams: URLSearchParams): SearchPartnerDriversPayload => {
  const email = (searchParams.get('email') ?? '').trim()
  const phone = normalizePhoneQuery(searchParams.get('phone') ?? '')
  const partnerDriverId = (searchParams.get('partnerDriverId') ?? '').trim()
  const query: SearchPartnerDriversPayload = {}

  if (email !== '') {
    query.email = email
  }

  if (phone !== '') {
    query.phone = phone
  }

  if (partnerDriverId !== '') {
    query.partnerDriverId = partnerDriverId
  }

  return query
}

export const hasSearchQuery = (query: SearchPartnerDriversPayload): boolean => {
  return Boolean(query.email || query.phone || query.partnerDriverId)
}

export const buildSearchParams = (values: {
  email: string
  phone: string
  partnerDriverId: string
}): URLSearchParams => {
  const searchParams = new URLSearchParams()
  const email = values.email.trim()
  const phone = values.phone.trim()
  const partnerDriverId = values.partnerDriverId.trim()

  if (email !== '') {
    searchParams.set('email', email)
  }

  if (phone !== '') {
    searchParams.set('phone', phone)
  }

  if (partnerDriverId !== '') {
    searchParams.set('partnerDriverId', partnerDriverId)
  }

  return searchParams
}
